// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".one-category-description__name[data-v-6d211e3e]{font-size:1.25rem}.one-category-description__description[data-v-6d211e3e]{font-size:.75rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
